var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Spinner, Tabs as TabsComponent, } from '@dixa/lib-shared-habla';
import { useMemo } from 'react';
import { searchApi } from 'apis/search';
import { formatLocalizedNumber } from 'utils/formatting/number';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { maxResultsCount } from '../../utils/results/maxResultsCount';
import styles from './searchTabs.module.scss';
/**
 * Represents a component that is used to render the tabs that separate search
 * results.
 */
export const SearchTabs = ({ activeTab, onTabChange, }) => {
    const { params } = useAppSelector((state) => state.search);
    const { count, isFetching } = searchApi.endpoints.readAdvancedSearchResults.useQueryState({
        type: activeTab,
        params,
    }, {
        selectFromResult: (_a) => {
            var _b;
            var { data } = _a, rest = __rest(_a, ["data"]);
            return (Object.assign(Object.assign({}, rest), { count: Math.min((_b = data === null || data === void 0 ? void 0 : data.data.results.reduce((acc, result) => (acc += result.nb_hits), 0)) !== null && _b !== void 0 ? _b : 0, maxResultsCount) }));
        },
    });
    const tabs = useMemo(() => Object.keys(tabsRecord).map((type) => {
        const { label } = tabsRecord[type];
        const showCount = activeTab === type &&
            (!!params.query || params.filters.conditions.length > 0);
        const tabElement = (_jsxs(_Fragment, { children: [_jsx("span", { children: label }), showCount && (_jsx(Badge, Object.assign({ variant: "secondary", size: "small", className: styles.tabBadge }, { children: isFetching ? (_jsx(Spinner, { size: 12 })) : (formatLocalizedNumber(count).concat(count >= maxResultsCount ? '+' : '')) })))] }));
        return { id: type, label: tabElement };
    }), [
        activeTab,
        count,
        isFetching,
        params.filters.conditions.length,
        params.query,
    ]);
    return (_jsx("div", Object.assign({ className: styles.tabsContainer }, { children: _jsx(TabsComponent, { tabs: tabs, selectedId: activeTab, onChange: (tab) => onTabChange(tab), tabClassName: styles.tab, tabSelectedClassName: styles.tabSelected }) })));
};
const tabsRecord = {
    conversations: { label: 'Conversations' },
    notes: { label: 'Notes' },
    contacts: { label: 'Contacts' },
};
